export default __webpack_public_path__ + "static/media/flavour_bg.f86b5b3f.png";